(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kit-esencial-configuracion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smk-kit-config')) {
  customElements.define('smk-kit-config', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      this.addEventListener('change', () => this.update(), options);
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-continue]');
        if (!link) return;
        const target = document.getElementById(this.dataset.target);
        if (!target) {
          event.preventDefault();
          this.querySelector('[data-status]').textContent = 'La solicitud de cotización aún no está disponible en esta página.';
          return;
        }
        this.syncForms();
        this.querySelector('[data-status]').textContent = '';
      }, options);
      document.addEventListener('submit', (event) => {
        if (this.getForms().includes(event.target)) this.writeForm(event.target);
      }, { ...options, capture: true });
      document.addEventListener('DOMContentLoaded', () => this.update(), options);
      document.addEventListener('shopify:section:load', () => this.syncForms(), options);
      this.update();
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
    }
    getConfiguration() {
      return {
        kit: 'Kit de Seguridad Esencial',
        gloves: this.querySelector('[data-choice="gloves"]').value,
        boots: this.querySelector('[data-choice="boots"]').value,
        pole: this.querySelector('[data-choice="pole"]:checked').value
      };
    }
    getForms() {
      const target = document.getElementById(this.dataset.target);
      if (!target) return [];
      const forms = target.matches('form') ? [target] : Array.from(target.querySelectorAll('form'));
      return forms.filter(form => form.querySelector('input[name="form_type"][value="contact"]'));
    }
    writeForm(form) {
      const config = this.getConfiguration();
      const fields = {
        'contact[Kit]': config.kit,
        'contact[Clase de guantes]': config.gloves,
        'contact[Talla de botas MEX]': config.boots,
        'contact[Pértiga alicate PA-04]': config.pole
      };
      Object.entries(fields).forEach(([name, value]) => {
        let input = Array.from(form.querySelectorAll('input[data-smk-kit-field]')).find(el => el.name === name);
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.dataset.smkKitField = 'true';
          form.appendChild(input);
        }
        input.value = value;
      });
    }
    syncForms() { this.getForms().forEach(form => this.writeForm(form)); }
    update() {
      const config = this.getConfiguration();
      ['gloves', 'boots', 'pole'].forEach(key => {
        this.querySelector('[data-summary="' + key + '"]').textContent = config[key];
      });
      this.syncForms();
      this.dispatchEvent(new CustomEvent('smk:kit-config-change', { bubbles: true, detail: config }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-esencial-cotizacion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smk-kit-quote')) {
  customElements.define('smk-kit-quote', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      this.form = this.querySelector('form');
      this.sync = () => this.syncConfiguration();
      document.addEventListener('smk:kit-config-change', event => {
        if (event.target.matches('smk-kit-config') && event.target.dataset.target === this.dataset.anchor) this.sync();
      }, options);
      document.addEventListener('DOMContentLoaded', this.sync, options);
      document.addEventListener('shopify:section:load', this.sync, options);
      this.consent = this.querySelector('[data-wa-consent]');
      if (this.consent) this.consent.disabled = false;
      this.syncConsent();
      this.consent?.addEventListener('change', () => this.syncConsent(), options);
      this.querySelector('[data-consent-phone]')?.addEventListener('input', () => this.syncConsent(), options);
      this.form?.addEventListener('submit', (event) => {
        this.sync();
        this.syncConsent(true);
        if (!this.form.checkValidity()) {
          event.preventDefault();
          this.querySelector('[data-consent-date]').value = '';
          this.form.reportValidity();
        }
      }, options);
      this.querySelector('[data-wa]')?.addEventListener('click', this.sync, options);
      this.addAttribution();
      this.sync();
      customElements.whenDefined('smk-kit-config').then(() => { if (this.isConnected) this.sync(); });
    }
    disconnectedCallback() { this._controller?.abort(); this._controller = null; }
    syncConsent(submitting = false) {
      const checkbox = this.querySelector('[data-wa-consent]');
      const phone = this.querySelector('[data-consent-phone]');
      if (!checkbox || !phone) return;
      const accepted = checkbox.checked && !checkbox.disabled;
      phone.required = accepted;
      const digits = phone.value.replace(/\D/g, '');
      phone.setCustomValidity(accepted && (digits.length < 10 || digits.length > 15)
        ? 'Ingresa un teléfono válido con código de país para recibir mensajes por WhatsApp.' : '');
      this.querySelector('[data-phone-label]').textContent = accepted ? '*' : '(opcional)';
      this.querySelector('[data-consent-state]').value = accepted ? 'Sí - aceptación expresa en esta solicitud' : 'No otorgado en esta solicitud';
      this.querySelector('[data-consent-date]').value = accepted && submitting ? new Date().toISOString() : '';
    }
    getConfig() {
      const component = Array.from(document.querySelectorAll('smk-kit-config')).find(el => el.dataset.target === this.dataset.anchor);
      return component && typeof component.getConfiguration === 'function'
        ? component.getConfiguration()
        : { kit: 'Kit de Seguridad Esencial', gloves: 'Por definir', boots: 'Por definir', pole: 'Por confirmar' };
    }
    syncConfiguration() {
      // La confirmación del servidor no depende de JavaScript ni de un clic.
      if (this.querySelector('[data-success]')) return;
      const config = this.getConfig();
      const fields = { 'contact[Kit]': config.kit, 'contact[Clase de guantes]': config.gloves,
        'contact[Talla de botas MEX]': config.boots, 'contact[Pértiga alicate PA-04]': config.pole };
      this.querySelectorAll('[data-smk-kit-field]').forEach(input => { if (fields[input.name] !== undefined) input.value = fields[input.name]; });
      ['gloves','boots','pole'].forEach(key => {
        const node = this.querySelector('[data-quote-summary="' + key + '"]');
        if (node && node.textContent !== config[key]) node.textContent = config[key];
      });
      const wa = this.querySelector('[data-wa]');
      const number = this.dataset.whatsapp;
      if (wa && /^[1-9]\d{7,14}$/.test(number)) {
        const message = 'Hola, quiero cotizar el Kit de Seguridad Esencial.\nGuantes: ' + config.gloves + '\nBotas (MEX): ' + config.boots + '\nPértiga alicate: ' + config.pole;
        wa.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
      }
    }
    addAttribution() {
      if (!this.form || this.querySelector('[data-success]')) return;
      const params = new URLSearchParams(window.location.search);
      // Solo atribución de esta visita; no se guardan datos personales en el navegador.
      const values = { 'Página de solicitud': window.location.origin + window.location.pathname };
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key => {
        const value = params.get(key);
        if (value) values[key] = value.slice(0, 250);
      });
      Object.entries(values).forEach(([key, value]) => {
        let input = Array.from(this.form.querySelectorAll('[data-smk-attribution]')).find(el => el.dataset.smkAttribution === key);
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'contact[' + key + ']'; input.dataset.smkAttribution = key; this.form.appendChild(input); }
        input.value = value;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
